var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.elementStyle)},[_vm._l((_vm.row),function(i){return _vm._l((_vm.column),function(j){return _c('div',{key:("column-" + i + "-" + j),staticClass:"cell",style:(_vm.cellStyle(i, j))})})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }